import Swal from "sweetalert2";
import api from "../../../utilidades/interceptor";
import { desEncriptar } from "../../../utilidades/encriptacion";

const urlApi = process.env.REACT_APP_API_KEY;
const key = process.env.REACT_APP_CLAVE_INCRIPTACION;

export const getDataFecha = (inicio, fin, setState, setLoading) => {
    const { user } = JSON.parse(desEncriptar(sessionStorage.getItem('dataClient'), key));
    api.get(`${urlApi}/operaciones/routesStatus?tiempo_real=0&fecha_inicio=${inicio}&fecha_fin=${fin}&id=${user.ID}`)
        .then((res) => {
            setState(res.data);
            setLoading(false);
        })
        .catch((error) => {
            setLoading(false);
            Swal.fire({
                icon: "error",
                title: "Ocurrio un error",
                text: error,
            });
        });
}

export const getDataRealTime = (setState, setLoading) => {
    const { user } = JSON.parse(desEncriptar(sessionStorage.getItem('dataClient'), key));
    api.get(`${urlApi}/operaciones/routesStatus?tiempo_real=1&id=${user.ID}`)
        .then((res) => {
            setLoading(false);
            setState(res.data === "No se encontraron resultados" ? [] : res.data);
        })
        .catch((error) => {
            setLoading(false);
            Swal.fire({
                icon: "error",
                title: "Ocurrio un error",
                text: error,
            });
        });
}
